<script setup lang="ts">
import { defaultImageValues } from '~/layers/cms/app/types/cmsTypes'
import type { CmsData, CmsImage } from '~/layers/cms/app/types/cmsTypes'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import { inject, onMounted, ref } from 'vue'
import { getcurrentChosenElement, update_cms_values } from '~/layers/cms/app/plugins/cms-image-element'
import { getByPath, setByPath } from '~/layers/cms/app/utils/cmsDataHelper'
import { useState } from '#app'
import { useChooseFile } from '#imports'

const cmsData = useState<CmsData>('cmsData')

const dialogRef = inject<DialogRef>('dialogRef')
interface DialogRef {
  value: {
    close(): void
  }
}

const closeDialog = () => {
  if (!dialogRef) return
  dialogRef.value.close()
}

const cms_image = ref<CmsImage>(defaultImageValues)
const cms_data_path = ref<string[]>([])

const loadElementData = () => {
  const element = getcurrentChosenElement()
  if (!element) {
    closeDialog()
    return
  }
  cms_data_path.value = element
  cms_image.value = { ...defaultImageValues, ...getByPath(cmsData.value, cms_data_path.value)?.component_data } as CmsImage
}

onMounted(() => {
  loadElementData()
})

const { chooseFile } = useChooseFile()
const selectFile = async (key: keyof CmsImage) => {
  const newSrc = await chooseFile()
  if (newSrc) (cms_image.value as Record<string, unknown>)[key] = newSrc
}

const updateImage = () => {
  setByPath(cmsData.value, [...cms_data_path.value, 'component_data'], cms_image.value)
  update_cms_values(cms_image.value)
  closeDialog()
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center gap-4">
      <label
        for="input-text"
        class="w-24 font-semibold"
      >Grafika</label>
      <NuxtImg
        :src="cms_image.src"
        class="object-contain w-80 h-auto cursor-pointer"
        width="320"
        height="320"
        format="webp"
        quality="100"
        loading="lazy"
        alt="Nie wybrano obrazu"
        @click="selectFile('src')"
      />
    </div>
    <div class="flex items-center gap-4">
      <label
        for="input-text"
        class="w-24 font-semibold"
      >Alternatywny tekst</label>
      <InputText
        v-model="cms_image.alt"
        class="flex-auto"
        autocomplete="off"
      />
    </div>
    <div class="flex items-center gap-4">
      <label
        for="input-text"
        class="w-24 font-semibold"
      >Wysokość</label>
      <InputNumber
        v-model="cms_image.height"
        type="number"
        placeholder="opcjonalne"
        class="flex-auto"
        autocomplete="off"
        :min="0"
      />
    </div>
    <div class="flex items-center gap-4">
      <label
        for="input-text"
        class="w-24 font-semibold"
      >Szerokość</label>
      <InputNumber
        v-model="cms_image.width"
        type="number"
        placeholder="opcjonalne"
        class="flex-auto"
        autocomplete="off"
        :min="0"
      />
    </div>
    <div class="flex items-center gap-4">
      <label
        for="input-text"
        class="w-24 font-semibold"
      >Jakość</label>
      <InputNumber
        v-model="cms_image.quality"
        type="number"
        class="flex-auto"
        autocomplete="off"
        :min="0"
        :max="100"
      />
    </div>
    <div class="flex items-center gap-4">
      <label
        for="format-select"
        class="w-24 font-semibold"
      >Format</label>
      <Select
        v-model="cms_image.format"
        :options="['jpg', 'png', 'gif', 'webp', 'avif', 'pjpg']"
        input-id="format-select"
        class="flex-auto"
      />
    </div>
    <div class="flex items-center gap-4">
      <label
        for="format-select"
        class="w-24 font-semibold"
      >Loading</label>
      <Select
        v-model="cms_image.loading"
        :options="['lazy', 'eager']"
        input-id="format-select"
        class="flex-auto"
      />
    </div>
    <div class="flex items-center gap-4">
      <label
        for="format-select"
        class="w-24 font-semibold"
      >Fit</label>
      <Select
        v-model="cms_image.fit"
        :options="['cover', 'contain', 'fill', 'inside', 'outside']"
        input-id="format-select"
        class="flex-auto"
      />
    </div>

    <div class="flex justify-end gap-2">
      <Button
        type="button"
        label="Cancel"
        severity="secondary"
        @click="closeDialog"
      />
      <Button
        type="button"
        label="Save"
        @click="updateImage"
      />
    </div>
  </div>
</template>
